import styled from "styled-components";
import Typography from "common/Typography/Typography";
import { typography } from "@shared/common/Themes/typography";
import { TypographyProps } from "@shared/common/Typography/Typography";

const Text = styled(Typography).attrs<TextProps>((p) => {
  return {
    as: p.as ?? "p",
    $weight: p.$weight ?? typography.fontWeights.NORMAL,
    $size: p.$size ?? typography.fontSizes.M,
  };
})<TextProps>`
  ${(p) =>
    p.$isTwoLinesEllipsis &&
    `
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    overflow: hidden;
  `};
`;

export default Text;

type TextProps = TypographyProps & { $isTwoLinesEllipsis?: boolean };
